import React from 'react'

export type ContextProps = {
  pageProps: any
  setPageProps: (pageProps: any) => void
  // deprecated
  header: any
  setHeader: (header: any) => void
}

const defaultContext = {
  pageProps: null,
  setPageProps: () => {},
  header: null,
  setHeader: () => {},
}

export default React.createContext<ContextProps>(defaultContext)
